import { Box } from '@mui/material';
import { Attachment } from '../../../shared/models/shared.types';

type BoxToolProps = {
  name: string;
  icon: Attachment;
};

export const BoxTool = ({ name, icon }: BoxToolProps) => {
  return (
    <>
      <Box
        style={{
          width: '105px',
          height: '105px',
          borderRadius: '10px',
          borderColor: 'gray',
          border: '1px solid gray',
          backgroundColor: '#fff',
          position: 'relative',
        }}
      >
        <Box>
          <img
            style={{ maxWidth: '100px', maxHeight: '100px' }}
            alt={`${name} Icon`}
            src={icon?.url}
          />
        </Box>
        <Box
          style={{
            position: 'absolute',
            bottom: '0',
            paddingLeft: '5px',
            fontSize: '10px',
            width: '100%',
            backgroundColor: '#fff',
            borderBottomLeftRadius: '15px',
            borderBottomRightRadius: '15px',
          }}
        >
          {name}
        </Box>
      </Box>
    </>
  );
};
